module.exports = __webpack_public_path__ + "static/media/hero_img_succession_planning.85f4fed2.png";